import script from "./SocialFundMessageEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundMessageEditor.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundMessageEditor.vue?vue&type=style&index=0&id=63287c57&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63287c57"]])

export default __exports__